import { AirItemI, GetBookingMyMscResponse, PassengerI } from '@msc-b2c/interfaces/interfaces';
import { getPassengerItemsByCabinId, getPassengersInfoByItem } from './stateroomGenericUtils';
import { formatTime, replacePlaceholders } from '@msc-b2c/shared-utils';
import { FlightAemConfigLabelsI, FlightCustomDataI } from '@msc-b2c/interfaces/types';

export const getFlightItemsByCabinId = (
  cabinId: string,
  bookingData: GetBookingMyMscResponse
): AirItemI[] => {
  return bookingData.airItems?.filter((flight) => flight.relatedItem?.id === cabinId) || [];
};

export const getFlightCustomDataInfo = (
  cabinId: string,
  bookingData: GetBookingMyMscResponse,
  aemConfigLabels: FlightAemConfigLabelsI
): FlightCustomDataI[] => {
  const passengers: PassengerI[] = getPassengerItemsByCabinId(cabinId, bookingData);
  const flights: AirItemI[] = getFlightItemsByCabinId(cabinId, bookingData);

  return flights.map((flight) => {
    const passengerData = getPassengersInfoByItem(flight, passengers);

    const segments = flight.segments.map((segment) => ({
      airline: segment.airline.name || '',
      class: segment.cabinClassDescription || '',
      departureTime: formatTime(segment.departureTime),
      departureDate: segment.departureDate || '',
      departureAirport: segment.origin?.airportName || '',
      departureAirportCode: segment.origin?.airportCode || '',
      arrivalAirport: segment.destination?.airportName || '',
      arrivalAirportCode: segment.destination?.airportCode || '',
      arrivalTime: formatTime(segment.arrivalTime),
      arrivalDate: segment.arrivalDate || '',
      details: '',
    }));

    return {
      code: flight.id ?? '',
      passengers: passengerData,
      configLabels: aemConfigLabels,
      status: flight.bookingStatus?.description ?? '',
      segments,
    };
  });
};

export const getFlightEnrichedCustomDataInfo = (
  cabinId: string,
  bookingData: GetBookingMyMscResponse,
  aemConfigLabels: FlightAemConfigLabelsI,
  placeholders: Record<string, string>,
  labelsMap: Record<string, { description?: string; specialInstructions?: string }>
): FlightCustomDataI[] => {
  const flightData = getFlightCustomDataInfo(cabinId, bookingData, aemConfigLabels);
  flightData.forEach((flight) => {
    const flightCode = flight.code;
    flight.passengers.forEach((passenger, index) => {
      passenger.passengerLabel = replacePlaceholders(placeholders.passengerLabelPlaceholder, {
        passengerIndex: `${index + 1}`,
      });
    });
    flight.segments.forEach((segment) => {
      segment.details =
        labelsMap[flightCode]?.description ??
        labelsMap[flightCode]?.specialInstructions ??
        replacePlaceholders(placeholders.flightDetailsPlaceholder, {
          departureTime: segment.departureTime,
          departureDate: segment.departureDate,
          arrivalDate: segment.arrivalDate,
          arrivalTime: segment.arrivalTime,
          departureAirportCode: segment.departureAirportCode,
          arrivalAirportCode: segment.arrivalAirportCode,
          departureAirport: segment.departureAirport,
          arrivalAirport: segment.arrivalAirport,
        });
    });
  });

  return flightData;
};
